// extracted by mini-css-extract-plugin
module.exports = {"component":"checkbox-group-component--3VL9h"};